import React, { FC } from 'react'
import { Button, Modal, ModalProps, Typography } from 'antd'
import { useLocalization } from 'localization'
import Container from 'components/Container'
import http from 'api/http'

export interface IBlockerModal extends Pick<ModalProps, 'title'> {
	subtitle: string | JSX.Element
}

const BlockerModal: FC<IBlockerModal> = ({ title, subtitle }) => {
	const { t } = useLocalization()

	const onSubmit = () => {
		http.logout()
	}

	return (
		<Modal
			title={title}
			width={660}
			open
			closable={false}
			footer={[
				<Button type="primary" key="submit" danger onClick={onSubmit}>
					{t('actions.logout')}
				</Button>,
			]}
		>
			<Container display="flex" flexDirection="column" space="lg" spaceDirection="vertical">
				<Typography.Text>{subtitle}</Typography.Text>
			</Container>
		</Modal>
	)
}

export default BlockerModal
